<template>
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <rect class="dot"
      v-for="dot in dots"
      :key="dot.dotId"
      :class="dot.color"
      :x="dot.x"
      :y="dot.y"
      width="4"
      height="4"/>
  </svg>
</template>

<style lang="scss" scoped>

.dot {
  opacity: 0;
  &.yellow {
    fill: var(--color--accent);
  }
  &.green {
    fill: var(--color--action);
  }
  &:nth-child(4n) {
    animation: DotAnimation 1000ms ease-out infinite;
  }
  &:nth-child(4n+1) {
    animation: DotAnimation 1000ms 200ms ease-out infinite;
  }
  &:nth-child(4n+2) {
    animation: DotAnimation 1000ms 400ms ease-out infinite;
  }
  &:nth-child(4n+3) {
    animation: DotAnimation 1000ms 600ms ease-out infinite;
  }
}

@keyframes DotAnimation {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  35% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>

<script>
export default {
  data () {
    return {
      dots: [
        {
          dotId: 0,
          color: 'yellow',
          active: false,
          x: 6,
          y: 6
        },
        {
          dotId: 1,
          color: 'green',
          active: false,
          x: 14,
          y: 6
        },
        {
          dotId: 2,
          color: 'yellow',
          active: false,
          x: 22,
          y: 6
        },
        {
          dotId: 3,
          color: 'green',
          active: false,
          x: 6,
          y: 14
        },
        {
          dotId: 4,
          color: 'green',
          active: false,
          x: 14,
          y: 14
        },
        {
          dotId: 5,
          color: 'yellow',
          active: false,
          x: 22,
          y: 14
        },
        {
          dotId: 6,
          color: 'green',
          active: false,
          x: 6,
          y: 22
        },
        {
          dotId: 7,
          color: 'yellow',
          active: false,
          x: 14,
          y: 22
        },
        {
          dotId: 8,
          color: 'green',
          active: false,
          x: 22,
          y: 22
        }
      ]
    }
  }
}
</script>
